/* NOONCUP storefront behavior: sheets, bag, search, segmented control,
   iOS large-title header, sticky buy bar, scroll reveal. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (cents) => {
    const v = (cents / 100).toFixed(2);
    return (window.NC?.money || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- toast ---------- */
  const toastEl = $('[data-toast]'); let toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(() => (toastEl.hidden = true), 2200);
  }

  /* ---------- sheets (native <dialog>) with drag-to-dismiss on phones ---------- */
  function openSheet(id) {
    const d = document.getElementById(id); if (!d || d.open) return;
    d.style.transform = '';
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (id === 'cart-sheet') loadCart();
    if (id === 'search-sheet') setTimeout(() => $('[data-search-input]', d)?.focus(), 60);
  }
  function closeSheet(d) {
    if (!d?.open) return;
    d.style.transform = '';
    d.close();
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openSheet(o.dataset.open === 'cart' ? 'cart-sheet' : 'search-sheet'); return; }
    const c = e.target.closest('[data-close]');
    if (c) { closeSheet(c.closest('dialog')); return; }
    if (e.target.matches('dialog[data-sheet]')) closeSheet(e.target); // backdrop tap
  });
  $$('dialog[data-sheet]').forEach((d) => {
    d.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    // drag the grabber/head down to dismiss: 1:1 tracking, velocity decides
    let y0 = 0, t0 = 0, dy = 0, dragging = false;
    const handles = $$('[data-grab]', d);
    handles.forEach((h) => h.addEventListener('pointerdown', (e) => {
      if (innerWidth >= 900 || e.button !== 0 || e.target.closest('button, input, a')) return;
      dragging = true; y0 = e.clientY; t0 = performance.now(); dy = 0;
      h.setPointerCapture(e.pointerId); d.style.transition = 'none';
    }));
    handles.forEach((h) => h.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      dy = e.clientY - y0;
      const y = dy < 0 ? -Math.sqrt(-dy) * 2 : dy; // rubber-band upward
      d.style.transform = `translateY(${y}px)`;
    }));
    const end = () => {
      if (!dragging) return; dragging = false;
      d.style.transition = '';
      const v = dy / (performance.now() - t0);
      if (dy > d.offsetHeight * 0.3 || v > 0.6) { d.style.transform = 'translateY(100%)'; setTimeout(() => closeSheet(d), 260); }
      else d.style.transform = '';
    };
    handles.forEach((h) => { h.addEventListener('pointerup', end); h.addEventListener('pointercancel', end); });
  });

  /* ---------- bag ---------- */
  function setCount(n) {
    $$('[data-count]').forEach((c) => { c.textContent = n; c.dataset.n = n; });
    $$('[data-open="cart"]').forEach((b) => b.setAttribute('aria-label', `Bag, ${n} items`));
  }
  async function loadCart() {
    const r = await fetch(`${NC.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    renderCart(await r.json());
  }
  /* upsell: more from the same shipper (Collective ships one parcel per supplier) */
  const SHIP = JSON.parse(document.querySelector('[data-shippers]')?.textContent || '{}');
  const upCache = {};
  async function renderUpsell(cart) {
    const box = $('[data-upsell]'); if (!box) return;
    const count = {}; cart.items.forEach(it => { if (SHIP[it.vendor]) count[it.vendor] = (count[it.vendor] || 0) + it.quantity; });
    const v = Object.keys(count).sort((a, b) => count[b] - count[a])[0];
    if (!v) { box.hidden = true; return; }
    const s = SHIP[v];
    try {
      upCache[s.h] ||= (await (await fetch(`/collections/${s.h}/products.json?limit=40`)).json()).products;
      const inCart = new Set(cart.items.map(it => it.product_id));
      const picks = upCache[s.h].filter(p => !inCart.has(p.id) && p.variants.some(x => x.available) && !/chocolate bar|date sweetened/i.test(p.title)).slice(0, 3);
      if (!picks.length) { box.hidden = true; return; }
      $('[data-upsell-h]').textContent = `More from ${s.n}, same shipper`;
      $('[data-upsell-row]').innerHTML = picks.map(p => {
        const x = p.variants.find(q => q.available); const parts = p.title.split(/\s+[-\u2013]\s+/);
        const roaster = parts.length > 1 ? parts[0] : p.vendor;
        const name = (parts.length > 1 ? parts.slice(1).join(' ') : p.title).replace(/'/g, '').replace(/\s*\([^)]*\)\s*$/, '').replace(/\s*(Coffee Beans|Whole Bean Coffee)$/i, '');
        const img = p.images[0] ? p.images[0].src.replace(/(\.\w+)(\?|$)/, '_240x$1$2') : '';
        return `<div class="up"><a class="up__img" href="/products/${p.handle}">${img ? `<img src="${img}" alt="" width="120" height="120" loading="lazy">` : ''}</a>
          <div class="up__t"><span class="mono muted">${esc(roaster)}</span><a href="/products/${p.handle}">${esc(name)}</a><span class="price">$${Number(x.price).toFixed(2)}</span></div>
          <button class="pcard__add" type="button" data-add="${x.id}" data-title="${esc(name)}" aria-label="Add ${esc(name)} to bag"><svg class="icon" viewBox="0 0 24 24"><path d="M5 12h14"/><path d="M12 5v14"/></svg></button></div>`;
      }).join('');
      box.hidden = false;
    } catch (_) { box.hidden = true; }
  }
  /* ---------- bag levels: 3 coffees 5%, 6 coffees 8%, 10 coffees 10% (Guido 2026-11-03).
     Mirrors the 3 automatic discounts + collection cart-level-coffee made by scripts/cart-levels.mjs:
     change both together. Brewers, cups, kettles and chocolate bars do not count. ---------- */
  const LEVELS = [{ n: 3, off: 5, name: 'Daily cup' }, { n: 6, off: 8, name: 'Full pot' }, { n: 10, off: 10, name: 'Café' }];
  const STOPS = [0, ...LEVELS.map(l => l.n)];
  const isCoffee = (it) => !/^(Bonavita|Ovalware)$/.test(it.vendor) && !/chocolate bar|date sweetened/i.test(it.product_title);
  const coffeeCount = (cart) => cart.items.reduce((a, it) => a + (isCoffee(it) ? it.quantity : 0), 0);
  const levelAt = (n) => { let i = -1; LEVELS.forEach((l, k) => { if (n >= l.n) i = k; }); return i; };
  const fillAt = (n) => {
    if (n >= STOPS[STOPS.length - 1]) return 1;
    const k = STOPS.findIndex((v, j) => n < STOPS[j + 1]);
    return (k + (n - STOPS[k]) / (STOPS[k + 1] - STOPS[k])) / (STOPS.length - 1);
  };
  const plural = (n) => `${n} ${n === 1 ? 'coffee' : 'coffees'}`;
  const levelMsg = (n) => {
    const i = levelAt(n), next = LEVELS[i + 1];
    if (!next) return `${LEVELS[i].name}: ${LEVELS[i].off}% off every coffee in your bag.`;
    const left = next.n - n;
    return `Add ${left}${n ? ' more' : ''} ${left === 1 ? 'coffee' : 'coffees'} for ${next.off}% off every coffee.`;
  };
  function levelSkeleton(el) {
    const pos = (j) => `${(j / (STOPS.length - 1)) * 100}%`;
    el.innerHTML = `<div class="lvl__top"><span class="lvl__name" data-lv-name></span><span class="lvl__off" data-lv-off></span></div>
      <div class="lvl__track"><span class="lvl__fill" data-lv-fill></span>
        <ol class="lvl__nodes" aria-hidden="true">${STOPS.map((_, j) => `<li data-lv-node="${j - 1}" style="left:${pos(j)}"></li>`).join('')}</ol></div>
      <ol class="lvl__labels">${STOPS.map((v, j) => `<li data-lv-label="${j - 1}" style="left:${pos(j)}">${j ? `${j === STOPS.length - 1 ? plural(v) : v}<b>${LEVELS[j - 1].off}% off</b>` : `0<b>Start</b>`}</li>`).join('')}</ol>
      <p class="lvl__msg" data-lv-msg aria-live="polite"></p>
      <p class="lvl__note" data-lv-gear hidden>Brewers, kettles and cups do not count toward levels.</p>`;
  }
  const CONF = ['#FA4E01', '#C8DCF2', '#FFF8F3', '#FFE3D3'];
  function confetti(el, i) {
    const node = $(`[data-lv-node="${i}"]`, el); if (!node || reduce || !el.offsetParent) return;
    node.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(1)' }], { duration: 520, easing: 'cubic-bezier(.23,1,.32,1)' });
    const r = el.getBoundingClientRect(), nr = node.getBoundingClientRect();
    const ox = nr.left - r.left + nr.width / 2, oy = nr.top - r.top + nr.height / 2;
    for (let k = 0; k < 24; k++) {
      const c = document.createElement('span'); c.className = 'conf';
      c.style.cssText = `left:${ox}px;top:${oy}px;background:${CONF[k % CONF.length]}`;
      el.append(c);
      const x = (Math.random() - .5) * 300, y = -40 - Math.random() * 70, rot = (Math.random() - .5) * 540;
      c.animate([{ transform: 'translate(0,0) rotate(0)', opacity: 1 }, { transform: `translate(${x}px,${y + 110}px) rotate(${rot}deg)`, opacity: 0 }],
        { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(.23,1,.32,1)' }).onfinish = () => c.parentNode && c.parentNode.removeChild(c);
    }
  }
  let lastLevel = null;
  function renderLevel(cart) {
    const n = coffeeCount(cart), i = levelAt(n);
    const up = lastLevel !== null && i > lastLevel;
    $$('[data-level]').forEach((el) => {
      if (!el.firstChild) levelSkeleton(el);
      $('[data-lv-name]', el).textContent = i >= 0 ? LEVELS[i].name : 'Bag levels';
      $('[data-lv-off]', el).textContent = i >= 0 ? `${LEVELS[i].off}% off` : '';
      $('[data-lv-fill]', el).style.transform = `scaleX(${fillAt(n)})`;
      $$('[data-lv-node]', el).forEach((d) => { const k = +d.dataset.lvNode; d.classList.toggle('is-on', k < 0 ? n > 0 : k <= i); });
      $$('[data-lv-label]', el).forEach((d) => { const k = +d.dataset.lvLabel; d.classList.toggle('is-on', k >= 0 && k <= i); });
      $('[data-lv-msg]', el).textContent = levelMsg(n);
      $('[data-lv-gear]', el).hidden = !cart.items.some((it) => !isCoffee(it));
      if (up) confetti(el, i);
    });
    lastLevel = i;
    return { n, i, up };
  }
  /* boxes: Collective ships one box per supplier */
  function renderBoxes(cart) {
    const box = $('[data-boxes]'); if (!box) return;
    const by = {}; cart.items.forEach((it) => { const k = SHIP[it.vendor]?.n || it.vendor; by[k] = (by[k] || 0) + it.quantity; });
    const names = Object.keys(by);
    box.hidden = !names.length; if (!names.length) return;
    $('[data-boxes-h]').textContent = names.length === 1 ? 'Ships in 1 box' : `Ships in ${names.length} boxes`;
    $('[data-boxes-rows]').innerHTML = names.map((k) => `<div class="boxes__row"><span>${esc(k)}</span><span class="mono muted">${by[k]} ${by[k] === 1 ? 'item' : 'items'}</span></div>`).join('');
  }

  function renderCart(cart) {
    renderUpsell(cart);
    setCount(cart.item_count);
    const lv = renderLevel(cart);
    renderBoxes(cart);
    const lines = $('[data-cart-lines]'), empty = $('[data-cart-empty]'), foot = $('[data-cart-foot]');
    if (!lines) return lv;
    empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0;
    $('[data-cart-total]').textContent = fmt(cart.total_price);
    const save = $('[data-cart-save]');
    if (save) {
      save.hidden = !cart.total_discount;
      const lvT = cart.items.flatMap((it) => it.line_level_discount_allocations || [])[0]?.discount_application?.title;
      $('[data-cart-save-l]').textContent = lvT || 'Discount';
      $('[data-cart-save-v]').textContent = `\u2212${fmt(cart.total_discount)}`;
    }
    lines.innerHTML = cart.items.map((it, i) => {
      const parts = it.product_title.split(/\s+[-–]\s+/);
      const roaster = parts.length > 1 ? parts[0] : it.vendor;
      const name = (parts.length > 1 ? parts.slice(1).join(' - ') : it.product_title).replace(/'/g, '').replace(/\s*\([^)]*\)\s*$/, '').replace(/\s*(Coffee Beans|Whole Bean Coffee)$/i, '');
      const img = it.image ? it.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') : '';
      return `<div class="line" data-line="${i + 1}">
        <a class="line__img" href="${it.url}">${img ? `<img src="${img}" alt="" width="72" height="72" loading="lazy">` : ''}</a>
        <div style="min-width:0">
          <div class="line__r mono">${esc(roaster)}</div>
          <a class="line__t" href="${it.url}" style="text-decoration:none">${esc(name)}</a>
          <div class="line__qty" role="group" aria-label="Quantity for ${esc(name)}">
            <button type="button" data-q="${i + 1}" data-to="${it.quantity - 1}" aria-label="${it.quantity === 1 ? 'Remove' : 'Decrease'}"><svg class="icon icon--sm" viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button>
            <span aria-live="polite">${it.quantity}</span>
            <button type="button" data-q="${i + 1}" data-to="${it.quantity + 1}" aria-label="Increase"><svg class="icon icon--sm" viewBox="0 0 24 24"><path d="M5 12h14"/><path d="M12 5v14"/></svg></button>
          </div>
        </div>
        <span class="price">${it.original_line_price > it.final_line_price ? `<s class="line__was">${fmt(it.original_line_price)}</s>` : ''}${fmt(it.final_line_price)}</span>
      </div>`;
    }).join('');
    return lv;
  }
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-q]'); if (!q) return;
    const line = q.closest('.line'); const to = +q.dataset.to;
    if (to === 0) line.classList.add('is-leaving');
    const r = await fetch(`${NC.routes.change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.dataset.q, quantity: to }) });
    const cart = await r.json();
    setTimeout(() => renderCart(cart), to === 0 ? 200 : 0);
  });

  async function addToBag(id, qty, title, btn) {
    btn?.classList.add('is-loading');
    try {
      const r = await fetch(`${NC.routes.add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: +qty || 1 }] }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag');
      const c = await (await fetch(`${NC.routes.cart}.js`)).json();
      setCount(c.item_count); const lv = renderCart(c);
      if (navigator.vibrate) navigator.vibrate(12);
      if (btn?.classList.contains('pcard__add')) { btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1400); }
      const next = LEVELS[lv.i + 1];
      if (lv.up) toast(`${LEVELS[lv.i].name}: ${LEVELS[lv.i].off}% off every coffee`);
      else if (next && lv.n > 0) toast(`Added. ${plural(next.n - lv.n)} more for ${next.off}% off`);
      else toast(`${title || 'Coffee'} added to bag`);
    } catch (err) { toast(err.message); }
    finally { btn?.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add]'); if (!b) return;
    e.preventDefault(); addToBag(b.dataset.add, 1, b.dataset.title, b);
  });
  $$('form[data-buy]').forEach((f) => {
    f.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = $('[type=submit]', f);
      addToBag(f.id.value, f.quantity.value, btn.dataset.title, btn);
    });
    $$('[data-step]', f).forEach((s) => s.addEventListener('click', () => {
      const i = f.quantity; i.value = Math.max(1, Math.min(20, (+i.value || 1) + +s.dataset.step));
    }));
  });

  /* cart page: the level meter outside the sheet */
  if (location.pathname === NC.routes.cart) {
    fetch(`${NC.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then(renderLevel);
  }

  /* ---------- footer menus: accordions on phones, always open (and not a control) on desktop ---------- */
  const ftrMq = matchMedia('(min-width: 900px)'), ftrAcc = document.querySelectorAll('[data-ftr-acc]');
  const ftrSync = () => ftrAcc.forEach((d) => { const s = d.querySelector('summary'); d.open = ftrMq.matches; if (ftrMq.matches) s.tabIndex = -1; else s.removeAttribute('tabindex'); });
  ftrAcc.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => { if (ftrMq.matches) e.preventDefault(); }));
  ftrMq.addEventListener('change', ftrSync); ftrSync();

  /* ---------- roaster logo strip: hide the "more" hint once scrolled to the end ---------- */
  document.querySelectorAll('.logos__row').forEach((row) => {
    const end = () => row.closest('.logos').classList.toggle('is-end', row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
    row.addEventListener('scroll', end, { passive: true }); end();
  });

  /* ---------- sticky buy bar (PDP, phone and desktop) ---------- */
  const sticky = $('[data-stickybuy]'), buy = $('form[data-buy]');
  if (sticky && buy) {
    new IntersectionObserver(([en]) => {
      const on = !en.isIntersecting && en.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on);
      $('[data-stickybuy-btn]', sticky).tabIndex = on ? 0 : -1;
    }).observe(buy);
    $('[data-stickybuy-btn]', sticky).addEventListener('click', (e) => addToBag(buy.id.value, buy.quantity.value, $('[type=submit]', buy).dataset.title, e.currentTarget));
  }

  /* ---------- predictive search ---------- */
  const si = $('[data-search-input]'), sr = $('[data-search-results]'), idle = $('[data-search-idle]');
  let st, ctrl;
  si?.addEventListener('input', () => {
    clearTimeout(st);
    st = setTimeout(async () => {
      const q = si.value.trim();
      if (q.length < 2) { sr.innerHTML = ''; idle.hidden = false; return; }
      ctrl?.abort(); ctrl = new AbortController();
      try {
        const r = await fetch(`${NC.routes.search}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=8&resources[options][fields]=title,product_type,vendor,tag,body`, { signal: ctrl.signal });
        const j = (await r.json()).resources.results;
        const rows = [
          ...(j.collections || []).map(c => `<a href="${c.url}"><span class="mono" style="display:grid;place-items:center;width:48px;height:48px;border:1px solid var(--ink);border-radius:10px;background:var(--sky)">${esc(c.title[0])}</span><span><span class="mono muted">Roaster or shelf</span><span class="sres__t" style="display:block">${esc(c.title)}</span></span></a>`),
          ...(j.products || []).map(p => { const parts = p.title.split(/\s+[-–]\s+/); return `<a href="${p.url}"><img src="${p.image || p.featured_image?.url || ''}" alt="" width="48" height="48" loading="lazy"><span><span class="mono muted">${esc(parts.length > 1 ? parts[0] : p.vendor)}</span><span class="sres__t" style="display:block">${esc((parts.length > 1 ? parts.slice(1).join(' ') : p.title).replace(/'/g, '').replace(/\s*\([^)]*\)$/, ''))}</span></span></a>`; }),
          ...(j.articles || []).map(a => `<a href="${a.url}"><span class="mono" style="display:grid;place-items:center;width:48px;height:48px;border:1px solid var(--ink);border-radius:10px;background:var(--peach)">G</span><span><span class="mono muted">Guide</span><span class="sres__t" style="display:block">${esc(a.title)}</span></span></a>`),
        ];
        idle.hidden = true;
        sr.innerHTML = rows.length ? rows.join('') : `<p class="note">No results for "${esc(q)}". Try a roaster, an origin such as Ethiopia, or a note such as chocolate.</p>`;
      } catch (_) { /* aborted */ }
    }, 160);
  });

  /* ---------- picker: group toggle + tiles ---------- */
  $$('[data-picker]').forEach((w) => {
    const bl = $('[data-picker-blurb]', w);
    const pick = (t, focus) => {
      $$('.ptk', w).forEach((x) => {
        const on = x === t, pan = document.getElementById(x.getAttribute('aria-controls'));
        x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; pan.hidden = !on;
        const lazy = on && pan.querySelector(':scope > template[data-lazy]'); if (lazy) lazy.replaceWith(lazy.content);
      });
      if (bl) { bl.textContent = t.dataset.blurb || ''; bl.hidden = !t.dataset.blurb; }
      if (focus) t.focus();
      t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    };
    $$('[data-tiles]', w).forEach((row) => {
      const tabs = $$('.ptk', row);
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => pick(t));
        t.addEventListener('keydown', (e) => { const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (d) { e.preventDefault(); pick(tabs[(i + d + tabs.length) % tabs.length], true); } });
      });
    });
    $$('.ptoggle__b', w).forEach((b) => b.addEventListener('click', () => {
      $$('.ptoggle__b', w).forEach((x) => x.setAttribute('aria-selected', x === b));
      $$('[data-tiles]', w).forEach((row) => { row.hidden = row.dataset.tiles !== b.dataset.group; });
      const first = $(`[data-tiles="${b.dataset.group}"] .ptk`, w); if (first) pick(first);
    }));
  });

  /* ---------- segmented control ---------- */
  $$('[data-seg]').forEach((w) => {
    const seg = $('.seg', w), thumb = $('.seg__thumb', seg), tabs = $$('[role=tab]', seg);
    const place = (t) => { thumb.style.width = `${t.offsetWidth}px`; thumb.style.transform = `translateX(${t.offsetLeft - 3}px)`; };
    const pick = (t, focus) => {
      tabs.forEach((x) => { const on = x === t; x.setAttribute('aria-selected', on); x.tabIndex = on ? 0 : -1; document.getElementById(x.getAttribute('aria-controls')).hidden = !on; });
      place(t); if (focus) t.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => pick(t));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (d) { e.preventDefault(); pick(tabs[(i + d + tabs.length) % tabs.length], true); }
      });
    });
    const init = () => place(tabs.find((t) => t.getAttribute('aria-selected') === 'true'));
    document.fonts?.ready.then(init); init(); addEventListener('resize', init, { passive: true });
  });

  /* ---------- header: hairline when stuck, iOS large-title collapse ---------- */
  const hdr = $('[data-hdr]'), big = $('[data-large-title]'), small = $('[data-hdr-title]');
  if (hdr) {
    const sentinel = document.createElement('div'); sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    document.body.prepend(sentinel);
    new IntersectionObserver(([e]) => hdr.classList.toggle('is-stuck', !e.isIntersecting)).observe(sentinel);
    if (big && small && !big.classList.contains('sr-only')) {
      small.textContent = big.textContent.trim();
      new IntersectionObserver(([e]) => hdr.classList.toggle('has-title', !e.isIntersecting && e.boundingClientRect.top < 0), { rootMargin: `-${hdr.offsetHeight}px 0px 0px 0px` }).observe(big);
    }
  }
  // back button: only when there is history inside the store
  $$('[data-back]').forEach((b) => {
    if (!document.referrer.startsWith(location.origin)) b.href = '/';
    else b.addEventListener('click', (e) => { e.preventDefault(); history.back(); });
  });

  /* ---------- shared-element view transition: card image -> product image ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.pcard a[href*="/products/"]'); if (!a) return;
    const img = $('.pcard__media img', a.closest('.pcard')); if (img) img.style.viewTransitionName = 'pimg';
  });
  addEventListener('pageshow', () => $$('.pcard__media img').forEach((i) => (i.style.viewTransitionName = '')));

  /* ---------- reveal ---------- */
  if (!reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach((el) => io.observe(el));
  } else $$('.reveal').forEach((el) => el.classList.add('is-in'));
})();

// PDP tabs (Details / Terms on this bag), same pattern as the Primal Wine product tabs: arrow keys move between tabs,
// only the selected tab is in the Tab order, the underline slides to the selected tab
(() => {
  document.querySelectorAll('[data-ptabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panes = tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
    const ind = root.querySelector('[data-ptabs-ind]');
    const move = (t) => { if (ind && t) { ind.style.width = t.offsetWidth + 'px'; ind.style.transform = 'translateX(' + t.offsetLeft + 'px)'; } };
    const select = (i) => {
      tabs.forEach((t, n) => { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
      panes.forEach((p, n) => { if (p) p.hidden = n !== i; });
      move(tabs[i]);
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        const n = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i - 1 + tabs.length) % tabs.length, Home: 0, End: tabs.length - 1 }[e.key];
        if (n !== undefined) { e.preventDefault(); tabs[n].focus(); select(n); }
      });
    });
    const init = () => move(root.querySelector('[aria-selected="true"]') || tabs[0]);
    requestAnimationFrame(init);
    if (document.fonts) document.fonts.ready.then(init);
    window.addEventListener('resize', init);
  });
})();

// Sticky filter bar: .is-stuck while it is pinned under the header, so it can show a bottom border (Guido 10-20)
(() => {
  const bars = [...document.querySelectorAll('.filters')];
  if (!bars.length) return;
  const check = () => bars.forEach((el) => {
    const top = parseFloat(getComputedStyle(el).top) || 0;
    const prev = el.previousElementSibling, prevBottom = prev ? prev.getBoundingClientRect().bottom : -Infinity;
    el.classList.toggle('is-stuck', el.getBoundingClientRect().top <= top + 1 && prevBottom < top);
  });
  let raf = 0;
  addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; check(); }); }, { passive: true });
  addEventListener('resize', check); check();
})();

// Brew guide calculator: water grams in, coffee grams out at the recipe's ratio; numbers in the steps follow (Guido 10-20)
(() => {
  const root = document.querySelector('[data-bguide][data-dose]');
  if (!root) return;
  const dose = +root.dataset.dose, water = +root.dataset.water, ratio = water / dose;
  const ins = root.querySelectorAll('[data-in="water"]');
  const set = (w) => {
    w = Math.max(50, Math.min(5000, Math.round(+w || water)));
    const d = Math.round((w / ratio) * 10) / 10;
    ins.forEach((i) => { if (+i.value !== w) i.value = w; });
    const dg = (d % 1 ? d.toFixed(1) : String(d)), wg = w.toLocaleString('en-US');
    root.querySelectorAll('[data-out="dose-n"]').forEach((e) => (e.textContent = dg));
    root.querySelectorAll('[data-out="water-n"]').forEach((e) => (e.textContent = wg));
    root.querySelectorAll('[data-out="dose"]').forEach((e) => (e.textContent = dg + ' g'));
    root.querySelectorAll('[data-out="water"]').forEach((e) => (e.textContent = wg + ' g'));
  };
  ins.forEach((i) => i.addEventListener('input', () => set(i.value)));
})();
